/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrganizationGroupType } from './OrganizationGroupType';
import {
    OrganizationGroupTypeFromJSON,
    OrganizationGroupTypeFromJSONTyped,
    OrganizationGroupTypeToJSON,
    OrganizationGroupTypeToJSONTyped,
} from './OrganizationGroupType';

/**
 * 
 * @export
 * @interface OrganizationGroupCreateRequest
 */
export interface OrganizationGroupCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof OrganizationGroupCreateRequest
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationGroupCreateRequest
     */
    shortName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationGroupCreateRequest
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationGroupCreateRequest
     */
    applicationId?: string | null;
    /**
     * 
     * @type {OrganizationGroupType}
     * @memberof OrganizationGroupCreateRequest
     */
    organizationGroupType?: OrganizationGroupType;
}



/**
 * Check if a given object implements the OrganizationGroupCreateRequest interface.
 */
export function instanceOfOrganizationGroupCreateRequest(value: object): value is OrganizationGroupCreateRequest {
    return true;
}

export function OrganizationGroupCreateRequestFromJSON(json: any): OrganizationGroupCreateRequest {
    return OrganizationGroupCreateRequestFromJSONTyped(json, false);
}

export function OrganizationGroupCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationGroupCreateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] === undefined ? undefined : json['name'] === null ? null : json['name'],
        'shortName': json['shortName'] === undefined ? undefined : json['shortName'] === null ? null : json['shortName'],
        'description': json['description'] === undefined ? undefined : json['description'] === null ? null : json['description'],
        'applicationId': json['applicationId'] === undefined ? undefined : json['applicationId'] === null ? null : json['applicationId'],
        'organizationGroupType': json['organizationGroupType'] == null ? undefined : OrganizationGroupTypeFromJSON(json['organizationGroupType']),
    };
}

export function OrganizationGroupCreateRequestToJSON(json: any): OrganizationGroupCreateRequest {
    return OrganizationGroupCreateRequestToJSONTyped(json, false);
}

export function OrganizationGroupCreateRequestToJSONTyped(value?: OrganizationGroupCreateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'shortName': value['shortName'],
        'description': value['description'],
        'applicationId': value['applicationId'],
        'organizationGroupType': OrganizationGroupTypeToJSON(value['organizationGroupType']),
    };
}

